<template>
	<!-- 다국어: 즐겨찾기 -->
	<sf-modal-layout :title="getMessage_('SWCC000439')" :show="opened" :closeModal="closeModal" size="s">
		<sf-data-table :columns="columns" :rows="favorites" height="680px">
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'delete'">
					<!-- 다국어: 삭제 -->
					<sf-button size="sm" :onClick="() => deleteFavorite(slotProps.row)">{{ getMessage_('SWCC000107') }}</sf-button>
				</template>
			</template>
		</sf-data-table>
		<template v-slot:footer>
			<!-- 다국어: 닫기 -->
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000113') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
//사용자의 즐겨찾기 화면들을 관리하는 팝업창
//즐겨찾기한 화면으로 접근할 수 있고, 즐겨찾기를 삭제할 수 있음
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		//헤더가 존재하는 Layout의 타입
		opened: {
			type: Boolean,
			default: false
		},

		openScreen: {
			type: Function,
			default: () => {}
		}
	},

	computed: {
		...rootComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000321'), //다국어: 화면명
					prop: 'scrName',
					minWidth: '200px',
					clickEvent: this.ServiceClick,
					highlight: true
				},
				{
					label: '',
					prop: 'delete',
					minWidth: '50px',
					sortable: false,
					custom: true
				}
			];
		}
	},
	watch: {
		//store의 즐겨찾기 팝업창 열림 상태 변경 감지
		opened() {
			//즐겨찾기 팝업창이 닫힘->열림 상태로 변경된 경우
			if (this.opened) {
				this.$sf_toggleLoading(true);

				//사용자의 즐겨찾기 리스트 조회 Action 호출
				this.getFavorite_()
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		}
	},
	methods: {
		...rootMethods,

		//즐겨찾기 화면 클릭
		ServiceClick(favorite) {
			// this.$sf_addTab(item, item.scrId, { scrId: item.scrId }); //tab에 화면 추가
			const item = { msgKey: favorite.msgKey, name: favorite.scrName, url: favorite.scrUrl, scrId: favorite.scrId };
			this.$emit('openScreen', { item }); //화면 오픈 이벤트 호출

			this.closeModal();
			// this.defaultAssign_({ key: 'favoritesModal', value: false }); //즐겨찾기 팝업창 열림 닫음 상태로 변경하기 위해 Action 호출
		},

		//즐겨찾기 화면 삭제
		deleteFavorite(favorite) {
			this.$sf_toggleLoading(true);

			//즐겨찾기 화면을 삭제하기 위해 Action 호출
			this.deleteFavorite_({ scrId: favorite.scrId })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//즐겨찾기 팝업창 닫기
		closeModal() {
			this.$emit('closed'); //즐겨찾기 팝업창 열림 닫음 상태로 변경하기 위해 Action 호출
		}
	}
};
</script>
<style></style>
